import PropTypes from "prop-types";
import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

function Markdown({ renderHTML, className, children }) {
    if (renderHTML) {
        return (
            <div
                className={className || ''}
                dangerouslySetInnerHTML={{ __html: children }}
            />
        );
    }

    return <ReactMarkdown escapeHtml={false} rehypePlugins={[rehypeRaw]}>{children}</ReactMarkdown>;
}

export default Markdown;

Markdown.propTypes = {
    children: PropTypes.string.isRequired,
    className: PropTypes.string,
    renderHTML: PropTypes.bool,
};
